import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

export interface SectionPanelProps {
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  sx?: object;
}

/** Titled content region — light border, no heavy card chrome. */
const SectionPanel: React.FC<SectionPanelProps> = ({ title, subtitle, actions, children, sx }) => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 2,
      bgcolor: 'background.paper',
      overflow: 'hidden',
      ...sx,
    }}
  >
    {(title || actions) && (
      <>
        <Box
          sx={{
            px: 2.5,
            py: 1.75,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            {title && (
              <Typography variant="h6" component="h2">
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {actions}
        </Box>
        <Divider />
      </>
    )}
    <Box sx={{ p: 2.5 }}>{children}</Box>
  </Box>
);

export default SectionPanel;
